import React, { useRef, useState } from 'react';
import classnames from 'classnames';
import { useAtom } from 'jotai';
import { resultModalTitleAtom, visibleExchangeAtom, visibleResultAtom } from '@/store';
import { showToast } from '@/utils';
import { exchange } from '@/services/subscription';
import { getUserInfo } from '@/utils/user';
import BackIcon from '@/assets/image/new/back.png';
import CloseIcon from '@/assets/image/new/close-icon.png';

import styles from './index.module.css';
import { isWeb } from '@/utils/vip';

const ExchangeModule = () => {
  const [exchangeCode, setExchangeCode] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  const [visibleExchange, setVisibleExchange] = useAtom(visibleExchangeAtom);
  const [visibleResult, setVisibleResult] = useAtom(visibleResultAtom);
  const [resultModalTitle, setResultModalTitle] = useAtom(resultModalTitleAtom);

  const refDom = useRef<any>();

  const handleExchange = async () => {
    if (loading) return;
    const value = exchangeCode.trim();
    if (!value) {
      showToast('请输入兑换码', refDom.current);
      return;
    }

    try {
      setLoading(true);

      const res = await exchange(value);

      if (res.data.code === 0 && res.data.code === 0) {
        await getUserInfo();
        setResultModalTitle(
          isWeb ? '您已成功兑换美图设计室VIP会员!' : '您已成功兑换美图秀秀SVIP会员!'
        );
        setVisibleResult(true);
        setExchangeCode('');
      } else {
        showToast(res.data.message || '兑换失败，请稍后再试~');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={classnames(styles.module, visibleExchange && styles.active)} ref={refDom}>
      <div className={styles.nav}>
        <img
          className={styles.navIcon}
          src={BackIcon}
          alt=""
          onClick={() => setVisibleExchange(false)}
        />
        <span onClick={() => setVisibleExchange(false)}>返回购买</span>
      </div>
      <div className={styles.content}>
        <div className={styles.title}>请输入会员兑换码</div>
        <div className={styles.inputBox}>
          <input
            className={styles.exchangeInput}
            type="text"
            placeholder="请输入兑换码"
            value={exchangeCode}
            maxLength={50}
            disabled={loading}
            onChange={(e) => setExchangeCode(e.target.value)}
          />
          {exchangeCode && !loading ? (
            <img
              className={styles.inputClear}
              src={CloseIcon}
              alt=""
              onClick={() => setExchangeCode('')}
            />
          ) : null}
        </div>
        <div
          className={classnames(styles.btn, loading && styles.disabled)}
          onClick={handleExchange}
        >
          <span>立即兑换</span>
          {loading ? <span className={styles.loadinng}></span> : null}
        </div>
      </div>
      <div className={styles.tips}>
        <div className={styles.subTitle}>兑换须知</div>
        <div className={styles.tipsDetail}>
          1.登录账号后，输入兑换码即可完成兑换。
          <br />
          2.兑换成功后，可享受对应的会员权益和服务。
          <br />
          3.请在兑换码有效期内使用，过期作废，不可退款。
          <br />
          4.此卡严禁倒卖、转让，不可兑换现金，不支持开发票。
          <br />
          5.请妥善保管，遗失、泄露、登错账号等不补。
        </div>
      </div>
    </div>
  );
};

export default React.memo(ExchangeModule);
